import { cx } from '@twind/core';
import phoneIconSrc from 'app/assets/icons/phone.svg';
import AlertIcon from 'app/components/icons/AlertIcon';
import useVirtualAssistantTracking from 'app/modules/virtual-assistant/hooks/useVirtualAssistantTracking';
import { type LocationResult } from 'app/services/chatBot';

import { getLocationStatusAndHours, isLocationBrandEducated } from './util';

const LocationCard = ({ location }: { location: LocationResult }) => {
  const { captureLocationResultClick } = useVirtualAssistantTracking();

  const plainPhoneNumber = location.phone_number.replace(/[^\d]/g, '');
  const href = `tel:${plainPhoneNumber}`;
  const formattedDistance = location.distance.replace(/[^\d.]/g, '');
  const { isOpen, hours } = getLocationStatusAndHours(location, new Date());
  const isBrandEducated = isLocationBrandEducated(location);

  const handleClick = () => {
    captureLocationResultClick(location.place_id, href);
  };

  return (
    <article className="text-xs text-typography-description">
      <address className="not-italic">
        <a
          href={href}
          className="border-1 rounded-1 px-4 py-3 flex flex-col gap-[2px]"
          onClick={handleClick}
        >
          <header className="flex gap-x-4 items-start">
            <h2 className="font-semibold text-sm text-[#272929] grow">{location.name}</h2>
            {isBrandEducated && (
              <div className="group bg-[#E1E3C9] py-1 px-2 rounded-[12px] whitespace-nowrap flex gap-1 items-center relative text-[#1A1A1A]">
                {location.tags[0]}
                <AlertIcon className="w-[12px] h-[12px] text-[black]" />
                <div className="w-[202px] p-2 absolute top-[100%] right-0 whitespace-normal bg-[white] drop-shadow-[0px_0px_6px_#00000040] rounded-[4px] mt-[10px] text-[#4B4D4D] hidden group-hover:block after:content-[''] after:block after:w-[0px] after:h-[0px] after:border-l-[6px] after:border-l-transparent after:border-r-[6px] after:border-r-transparent after:border-b-[6px] after:border-b-[white] after:absolute after:bottom-[100%] after:right-[7px]">
                  Provider has received specialized training for this medication.
                </div>
              </div>
            )}
          </header>
          <div className="grid grid-cols-[1fr_48px]">
            <div>
              <p>{formattedDistance} miles from you</p>
              <p>{location.address}</p>
              <p>
                {location.city}, {location.state} {location.zipcode}
              </p>
              <p>
                <span className={cx('font-semibold', isOpen ? 'text-[#5FA560]' : 'text-[#D65C5C]')}>
                  {isOpen ? 'Open' : 'Closed'}
                </span>
                {hours && ` · ${hours}`}
              </p>
            </div>
            <img
              src={phoneIconSrc}
              className="w-8 h-8 justify-self-end self-end"
            />
          </div>
        </a>
      </address>
    </article>
  );
};

export default LocationCard;
